const state = () => ({
  audit_schedule:null,
  audit_schedules:[],
  showdetailsmodal:false,
  selectedevent:null,
});
const getters = {
  audit_schedule(state){
    return state.audit_schedule
  },
  audit_schedules(state){
    return state.audit_schedules
  },
  showdetailsmodal(state){
    return state.showdetailsmodal
  },
  selectedevent(state){
    return state.selectedevent
  },
};
const  mutations =  {
  SET_AUDIT_SCHEDULE(state,data){
    state.audit_schedule = data
  },
  SET_AUDIT_SCHEDULES(state,data){
    state.audit_schedules = data
  },
  SET_SHOW_DETAIL_MODAL(state,data){
    state.showdetailsmodal = data
  },
  SET_SELECTED_EVENT(state,data){
    state.selectedevent = data
  },
};
const actions =  {
  setAuditSchedule({commit},data)  {
    commit("SET_AUDIT_SCHEDULE",data)
  },
  setAuditSchedules({commit},data)  {
    commit("SET_AUDIT_SCHEDULES",data)
  },
  setShowDetailModal({commit},data)  {
    commit("SET_SHOW_DETAIL_MODAL",data)
  },
  setSelectedEvent({commit},data)  {
    commit("SET_SELECTED_EVENT",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

